import { LoadingOutlined } from "@ant-design/icons"
import { Button, PageHeader, Table } from "antd"
import { ColumnsType } from "antd/lib/table"
import moment from "moment"
import React, { useEffect } from "react"
import { Download } from "react-feather"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { NotificationService } from "Shared/services"
import ExportHistoryService from "Shared/services/exportHistory.service"
import { downloadFileAsSignedUrl, sortItemsDescByDateField } from "Shared/utils/helpers"
import useStateIfMounted from "Shared/utils/hooks/useStateIfMounted"

const ExportHistoryList = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const [isLoading, setIsLoading] = useStateIfMounted(false)
    const [exportHistory, setExportHistory] = useStateIfMounted<any[]>([])

    useEffect(() => {
        let isFetching = true

        const fetchExportHistory = async () => {
            try {
                if (!isFetching) return
                setIsLoading(true)
                const exportHistory = sortItemsDescByDateField(await ExportHistoryService.fetchHistory(), "exportDate")
                isFetching && setExportHistory(exportHistory)
            } catch (err) {
                NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:fetch.title"), t("error:fetch.message"))
            } finally {
                setIsLoading(false)
            }
        }

        fetchExportHistory()

        return () => {
            isFetching = false
        }
    }, [])

    const columns: ColumnsType = [
        {
            title: t("label:export_history.export_date"),
            key: "exportDate",
            render: ({ exportDate }: any) => <span>{moment(exportDate).format("lll")}</span>,
        },
        {
            title: t("label:export_history.resource.title"),
            key: "resource",
            render: ({ resource }: any) => <span>{t(`label:export_history.resource.${resource?.toLowerCase()}`)}</span>,
        },
        {
            title: t("label:export_history.format"),
            key: "resource",
            render: ({ format }: any) => <span>{t(`input:export.export_format.${format}`)}</span>,
        },
        {
            title: t("label:export_history.download"),
            key: "download",
            width: 100,
            align: "center",
            render: ({ fileUrl }: any) => (
                <Button className="m-5 btn-default" icon={<Download />} onClick={() => handleFileDownload(fileUrl)} disabled={isLoading} loading={isLoading} />
            ),
        },
    ]

    const handleFileDownload = async (url: string) => {
        try {
            downloadFileAsSignedUrl(url)
        } catch (error) {
            NotificationService.showErrorNotificationBasedOnResponseError(error, t("error:error"))
        }
    }

    return (
        <div id="finway-export-history" className="w-full">
            <div className="md:hidden">
                <PageHeader ghost={false} onBack={() => history.push("/settings")} title={<h2 className="mb-0">{t("label:export_history.title")}</h2>}></PageHeader>
            </div>
            <div className="justify-between items-center mb-10 hidden md:flex xs:items-center">
                <h2 className="mb-0">{t("label:export_history.title")}</h2>
            </div>
            {exportHistory.length === 0 ? (
                <div className="text-text-dark p-10">{t("missing:no_export_history")}</div>
            ) : (
                <div className="p-5 w-full overflow-y-auto overflow-x-hidden">
                    <Table
                        columns={columns}
                        dataSource={exportHistory}
                        rowKey="_id"
                        pagination={false}
                        loading={{
                            spinning: isLoading,
                            indicator: <LoadingOutlined style={{ fontSize: 30, color: "black" }} spin />,
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default React.memo(ExportHistoryList)
